(() => {
  const theme = window.theme || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(pointer: fine)').matches;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

  const formatMoney = (cents) => {
    const format = theme.moneyFormat || 'Rs.{{amount}}';
    const value = (cents / 100).toFixed(2);
    const [whole, dec] = value.split('.');
    const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amount = dec === '00' ? withCommas : `${withCommas}.${dec}`;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (key === 'amount_no_decimals' ? withCommas : amount));
  };

  /* Reveal on scroll. Anything already on screen when the page loads shows straight away. */
  let revealObserver = null;
  const initReveal = () => {
    const items = [...document.querySelectorAll('[data-reveal]:not(.is-in), .reveal:not(.is-in)')];
    if (!document.body.classList.contains('has-reveal') || reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const vh = window.innerHeight;
    items.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0 && !el.closest('.is-hidden')) el.classList.add('is-in');
    });
    document.documentElement.classList.add('reveal-ready');
    revealObserver = revealObserver || new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); revealObserver.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    items.filter((el) => !el.classList.contains('is-in')).forEach((el) => revealObserver.observe(el));
  };

  /* Cart */
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const setCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });
  };
  const bumpCount = () => {
    if (reduceMotion) return;
    document.querySelectorAll('.cart-pill__count').forEach((el) => {
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  };
  const openDrawer = () => {
    const d = drawer();
    if (!d || d.open) return;
    d.showModal();
    updateBuybar();
  };
  const renderDrawer = (html) => {
    const d = drawer();
    if (!d || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    d.innerHTML = fresh.innerHTML;
    d.dataset.count = fresh.dataset.count;
    setCount(fresh.dataset.count);
  };
  const sectionsUrl = () => window.location.pathname;

  let toastTimer = 0;
  const showToast = (name, image) => {
    const toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.querySelector('[data-toast-name]').textContent = name || '';
    const media = toast.querySelector('[data-toast-media]');
    media.innerHTML = '';
    if (image) {
      const img = new Image();
      img.src = image;
      img.alt = '';
      media.append(img);
    }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 2200);
  };

  const addToCart = async (form, submitter) => {
    const button = submitter || form.querySelector('[type="submit"]');
    const label = button ? button.innerHTML : '';
    const quiet = button && button.hasAttribute('data-toast-add') && !form.closest('[data-cart-drawer]');
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', sectionsUrl());
    try {
      const res = await fetch(`${theme.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || theme.strings.error);
      renderDrawer(data.sections && data.sections['cart-drawer']);
      bumpCount();
      if (quiet) {
        showToast(button.dataset.name, button.dataset.image);
        if (button) {
          button.removeAttribute('aria-busy');
          button.disabled = false;
          button.classList.add('is-added');
          button.textContent = theme.strings.added;
          setTimeout(() => { button.classList.remove('is-added'); button.innerHTML = label; }, 1400);
        }
        return;
      }
      openDrawer();
    } catch (err) {
      showFormError(form, err.message);
    }
    if (button) { button.removeAttribute('aria-busy'); button.disabled = false; button.innerHTML = label; }
  };

  const showFormError = (form, message) => {
    let box = form.nextElementSibling && form.nextElementSibling.classList.contains('form-error') ? form.nextElementSibling : null;
    if (!box) {
      box = document.createElement('p');
      box.className = 'form-error';
      box.setAttribute('role', 'alert');
      form.after(box);
    }
    box.textContent = message;
  };

  const changeLine = async (line, quantity) => {
    const d = drawer();
    d && d.classList.add('is-busy');
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: 'cart-drawer', sections_url: sectionsUrl() })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || theme.strings.error);
      renderDrawer(data.sections && data.sections['cart-drawer']);
    } catch (err) {
      window.location.href = theme.routes.cart;
    } finally {
      d && d.classList.remove('is-busy');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.js-add-form');
    if (!form || !drawer()) return;
    const button = event.submitter || form.querySelector('[type="submit"]');
    const quiet = button && button.hasAttribute('data-toast-add');
    if (!theme.cartDrawer && !quiet) return;
    event.preventDefault();
    addToCart(form, event.submitter);
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('.js-open-cart');
    if (opener && theme.cartDrawer && drawer() && !document.body.classList.contains('template-cart')) {
      event.preventDefault();
      openDrawer();
      return;
    }
    const d = drawer();
    if (d && (event.target === d || event.target.closest('[data-close-drawer]'))) {
      d.close();
      return;
    }
    const lineBtn = event.target.closest('[data-line-qty]');
    if (lineBtn) {
      const line = Number(lineBtn.closest('[data-line]').dataset.line);
      changeLine(line, Math.max(0, Number(lineBtn.dataset.lineQty)));
      return;
    }
    const qtyBtn = event.target.closest('[data-qty]');
    if (qtyBtn) {
      const input = qtyBtn.parentElement.querySelector('input');
      input.value = Math.max(1, (Number(input.value) || 1) + Number(qtyBtn.dataset.qty));
      return;
    }
    const copy = event.target.closest('[data-copy]');
    if (copy && navigator.clipboard) {
      navigator.clipboard.writeText(copy.dataset.copy).then(() => { copy.textContent = copy.dataset.copied; });
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('.js-autosubmit')) event.target.form.submit();
  });

  /* Header background once the page scrolls */
  const header = () => document.querySelector('[data-header]');

  /* Sticky order bar: after the first screen, never over the range showcase or the open cart */
  const updateBuybar = () => {
    const bar = document.querySelector('[data-buybar]');
    if (!bar) return;
    const vh = window.innerHeight;
    const range = document.querySelector('[data-range]');
    let inRange = false;
    if (range) { const r = range.getBoundingClientRect(); inRange = r.top < vh && r.bottom > 0; }
    const d = drawer();
    const show = window.scrollY > vh * 0.9 && !inRange && !(d && d.open);
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    bar.inert = !show;
  };

  /* Range showcase: scroll position picks the product */
  const updateRange = () => {
    document.querySelectorAll('[data-range]').forEach((range) => {
      const texts = [...range.querySelectorAll('[data-range-item]')];
      const imgs = [...range.querySelectorAll('.range__img')];
      const glows = [...range.querySelectorAll('[data-range-glow]')];
      const n = texts.length;
      if (!n) return;
      const r = range.getBoundingClientRect();
      const span = r.height - window.innerHeight;
      const prog = span > 0 ? clamp(-r.top / span, 0, 1) : 0;
      const idx = Math.min(n - 1, Math.floor(prog * n));
      if (range.dataset.idx === String(idx)) return;
      range.dataset.idx = idx;
      const mark = (el, i) => {
        el.classList.toggle('is-active', i === idx);
        el.classList.toggle('is-past', i < idx);
      };
      texts.forEach((el, i) => { mark(el, i); el.inert = i !== idx; });
      imgs.forEach(mark);
      glows.forEach((el, i) => el.classList.toggle('is-active', i === idx));
      const num = range.querySelector('[data-range-num]');
      if (num) num.textContent = String(idx + 1).padStart(2, '0');
    });
  };

  /* Parallax backgrounds */
  const updateParallax = () => {
    if (reduceMotion) return;
    const vh = window.innerHeight;
    document.querySelectorAll('[data-parallax]').forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const s = Number(el.dataset.parallax) || 0;
      el.style.transform = `translate3d(0, ${((r.top + r.height / 2 - vh / 2) * -s).toFixed(1)}px, 0)`;
    });
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      const h = header();
      if (h) h.classList.toggle('is-scrolled', window.scrollY > 40);
      updateRange();
      updateParallax();
      updateBuybar();
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  document.addEventListener('close', (event) => {
    if (event.target.matches && event.target.matches('[data-cart-drawer]')) updateBuybar();
  }, true);

  /* Bundle line-up: products rise in, then a spotlight moves along them */
  const initBundles = () => {
    document.querySelectorAll('[data-bundle]:not([data-bound])').forEach((bundle) => {
      bundle.dataset.bound = 'true';
      const imgs = [...bundle.querySelectorAll('.bundle__img')];
      if (!('IntersectionObserver' in window)) { bundle.classList.add('is-in'); return; }
      let timer = 0;
      let interval = 0;
      let spot = 1;
      const step = () => {
        spot = (spot + 1) % imgs.length;
        imgs.forEach((img, i) => img.classList.toggle('is-spot', i === spot));
      };
      new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          bundle.classList.add('is-in');
          if (reduceMotion || imgs.length < 2 || interval || timer) return;
          timer = setTimeout(() => {
            bundle.classList.add('has-spot');
            step();
            interval = setInterval(step, 2200);
          }, bundle.classList.contains('has-spot') ? 0 : 1700);
        } else {
          clearTimeout(timer);
          clearInterval(interval);
          timer = 0;
          interval = 0;
        }
      }, { threshold: 0.3 }).observe(bundle);
    });
  };

  /* Home filter buttons */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-filter]');
    if (!btn) return;
    const shop = btn.closest('[data-shop]');
    if (!shop) return;
    const key = btn.dataset.filter;
    shop.querySelectorAll('[data-filter]').forEach((b) => {
      const on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
    shop.querySelectorAll('.pcard').forEach((card) => {
      const cats = (card.dataset.cats || '').split(' ');
      card.classList.toggle('is-hidden', key !== 'all' && !cats.includes(key));
    });
    initReveal();
  });

  /* One open answer at a time, for browsers without <details name> */
  if (!('name' in HTMLDetailsElement.prototype)) {
    document.addEventListener('toggle', (event) => {
      const el = event.target;
      if (!(el instanceof HTMLDetailsElement) || !el.open || !el.getAttribute('name')) return;
      document.querySelectorAll(`details[name="${el.getAttribute('name')}"]`).forEach((other) => {
        if (other !== el) other.open = false;
      });
    }, true);
  }

  /* Desktop pointer effects: cursor dot, magnetic button, card tilt, hero glow */
  const initPointer = () => {
    if (!finePointer || reduceMotion) return;
    const dot = document.querySelector('[data-cursor-dot]');
    if (dot && document.body.hasAttribute('data-cursor')) {
      let tx = -100; let ty = -100; let x = -100; let y = -100; let raf = 0;
      const loop = () => {
        x += (tx - x) * 0.18;
        y += (ty - y) * 0.18;
        dot.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        raf = Math.abs(tx - x) + Math.abs(ty - y) > 0.3 ? requestAnimationFrame(loop) : 0;
      };
      window.addEventListener('mousemove', (e) => {
        tx = e.clientX;
        ty = e.clientY;
        dot.classList.add('is-on');
        dot.classList.toggle('is-big', Boolean(e.target.closest && e.target.closest('a, button, summary, label')));
        if (!raf) raf = requestAnimationFrame(loop);
      }, { passive: true });
      document.addEventListener('mouseleave', () => dot.classList.remove('is-on'));
    }

    window.addEventListener('mousemove', (e) => {
      document.querySelectorAll('[data-magnet]').forEach((el) => {
        const r = el.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2);
        const dy = e.clientY - (r.top + r.height / 2);
        el.style.transform = Math.hypot(dx, dy) < 140 ? `translate(${dx * 0.25}px, ${dy * 0.35}px)` : '';
      });
    }, { passive: true });

    document.addEventListener('mousemove', (e) => {
      const card = e.target.closest && e.target.closest('[data-tilt]');
      if (!card) return;
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = `perspective(1000px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) translateY(-6px)`;
    }, { passive: true });
    document.addEventListener('mouseout', (e) => {
      const card = e.target.closest && e.target.closest('[data-tilt]');
      if (card && !card.contains(e.relatedTarget)) card.style.transform = '';
    });

    document.addEventListener('mousemove', (e) => {
      const hero = e.target.closest && e.target.closest('[data-hero]');
      if (!hero) return;
      const r = hero.getBoundingClientRect();
      hero.style.setProperty('--mx', `${e.clientX - r.left}px`);
      hero.style.setProperty('--my', `${e.clientY - r.top}px`);
    }, { passive: true });
  };

  /* Product page */
  const initProduct = (root) => {
    const form = document.getElementById(root.dataset.formId);
    const track = root.querySelector('[data-gallery-track]');
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const section = root.closest('.shopify-section') || document;
    const sticky = section.querySelector('[data-sticky-atc]');

    const showMedia = (id, smooth = true) => {
      if (!track || !id) return;
      const slide = track.querySelector(`[data-media-id="${id}"]`);
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === String(id))));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumb)));
    if (track && thumbs.length) {
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
        });
      }, { passive: true });
    }

    const picker = root.querySelector('[data-variant-picker]');
    if (picker && form) {
      const variants = JSON.parse(picker.querySelector('[data-variants]').textContent);
      const idInput = form.querySelector('[data-variant-id]');
      const atc = form.querySelector('[data-atc]');
      const atcLabel = form.querySelector('[data-atc-label]');
      const price = root.querySelector('[data-price]');
      const stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
      const stickyBtn = sticky && sticky.querySelector('[data-sticky-btn]');

      picker.addEventListener('change', () => {
        const selected = [...picker.querySelectorAll('fieldset')].map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        if (!variant) {
          atc.disabled = true;
          atcLabel.textContent = theme.strings.unavailable;
          return;
        }
        idInput.value = variant.id;
        atc.disabled = !variant.available;
        atcLabel.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        if (stickyBtn) stickyBtn.disabled = !variant.available;
        if (price) {
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          price.querySelector('[data-price-now]').textContent = formatMoney(variant.price);
          if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
          const was = price.querySelector('[data-price-was]');
          const save = price.querySelector('[data-price-save]');
          price.classList.toggle('price--sale', Boolean(onSale));
          if (was) {
            was.hidden = !onSale;
            if (onSale) was.querySelector('[data-price-was-amount]').textContent = formatMoney(variant.compare_at_price);
          }
          if (save) {
            save.hidden = !onSale;
            if (onSale) {
              const diff = variant.compare_at_price - variant.price;
              const pct = Math.floor((diff * 100) / variant.compare_at_price);
              save.textContent = theme.strings.save.replace('[amount]', formatMoney(diff)).replace('[percent]', pct);
            }
          }
        }
        if (variant.featured_media) showMedia(variant.featured_media.id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      });
    }

    const mainAtc = form && form.querySelector('[data-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', String(!past));
        sticky.querySelector('[data-sticky-btn]').tabIndex = past ? 0 : -1;
      }).observe(mainAtc);
    }
  };

  const initRecommendations = async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        initReveal();
      }
    } catch (err) {
      el.remove();
    }
  };

  /* 3D models: viewer loads after the page has finished loading, only for models near the viewport */
  let viewerModule = null;
  const initModels = () => {
    const src = document.body.dataset.viewerSrc;
    if (!src || !('IntersectionObserver' in window)) return;
    const els = [...document.querySelectorAll('[data-model-src]:not([data-viewer-mounted])')].filter(
      (el) => el.dataset.modelSrc && (!el.dataset.minWidth || window.innerWidth >= Number(el.dataset.minWidth))
    );
    if (!els.length) return;
    const start = () => {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          viewerModule = viewerModule || import(src);
          viewerModule.then((mod) => mod.mount(entry.target)).catch(() => {});
        });
      }, { rootMargin: '200px 0px' });
      els.forEach((el) => io.observe(el));
    };
    let started = false;
    const go = () => { if (started) return; started = true; start(); };
    const idle = () => ('requestIdleCallback' in window ? window.requestIdleCallback(go, { timeout: 2500 }) : setTimeout(go, 200));
    const afterLoad = (fn) => (document.readyState === 'complete' ? fn() : window.addEventListener('load', fn, { once: true }));
    if (window.innerWidth >= 990) {
      afterLoad(idle);
    } else {
      ['scroll', 'touchstart', 'pointerdown'].forEach((e) => window.addEventListener(e, go, { passive: true, once: true }));
      afterLoad(() => setTimeout(go, 7000));
    }
  };

  const initReviewPanel = () => {
    document.querySelectorAll('[data-review-panel]').forEach((panel) => {
      const form = panel.querySelector('form');
      if (/contact_posted=true/.test(window.location.search) || (form && form.querySelector('.errors, .review-form__ok'))) {
        panel.open = true;
        panel.scrollIntoView({ block: 'start' });
      }
    });
  };

  const init = () => {
    initReviewPanel();
    initReveal();
    initModels();
    initBundles();
    document.querySelectorAll('[data-range]').forEach((r) => { delete r.dataset.idx; });
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    document.querySelectorAll('[data-recommendations]').forEach((el) => {
      if (!el.children.length) initRecommendations(el);
    });
    onScroll();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  initPointer();

  document.addEventListener('shopify:section:load', init);

  /* Theme editor: selecting a product in the range showcase scrolls to it */
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest && event.target.closest('[data-range-item]');
    const range = item && item.closest('[data-range]');
    if (!range) return;
    const items = [...range.querySelectorAll('[data-range-item]')];
    const i = items.indexOf(item);
    const span = range.offsetHeight - window.innerHeight;
    const top = range.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: top + span * ((i + 0.5) / items.length), behavior: 'auto' });
  });
})();
